import { Controller, useFormContext } from "react-hook-form";
import { ui } from "../ui";

interface Props {
	label?: string;
	name: string;
	description?: string;
}

const Checkbox = ({ label, name, description }: Props) => {
	const { control } = useFormContext();

	return (
		<div className="flex items-start space-x-2">
			<Controller
				name={name}
				control={control}
				render={({ field: { value, onChange } }) => (
					<ui.Checkbox checked={value} onCheckedChange={onChange} id={name} />
				)}
			/>
			<div className="gap-1.5 grid leading-none">
				{label && (
					<ui.Label
						htmlFor={name}
						className="peer-disabled:opacity-70 font-medium text-sm leading-none peer-disabled:cursor-not-allowed"
					>
						{label}
					</ui.Label>
				)}
				{description && (
					<p className="text-muted-foreground text-sm">{description}</p>
				)}
			</div>
		</div>
	);
};

export default Checkbox;
